module.exports = __webpack_public_path__ + "img/viaFlight.c164cdc5.svg";